module.exports = __webpack_public_path__ + "media/whale sharks/whale-7ab3b453.jpg";